import { render, staticRenderFns } from "./CustomerDetailView.vue?vue&type=template&id=2d279ea6&"
import script from "./CustomerDetailView.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports